import { useCreateQuery, QueryOptions } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { IntegratorFormConfiguration } from './types';
import { integratorBaseModel } from './crud';

const getIntegratorsFormConfig = (integratorName: string) =>
  axiosService
    .get<IntegratorFormConfiguration[]>(
      `/integrators/configuration/${integratorName}`,
    )
    .then(({ data }) => data);

export const fetchEhrIntegratorsConfigurationByIntegratorName =
  () =>
  (
    { integratorName }: { integratorName: string },
    options?: QueryOptions<IntegratorFormConfiguration[]>,
  ) =>
    useCreateQuery<IntegratorFormConfiguration[]>(
      [...integratorBaseModel.keys.all, 'configuration', integratorName],
      getIntegratorsFormConfig,
      integratorName,
      options,
    );
